module.exports = __webpack_public_path__ + "img/8ff51ca.png";